// extracted by mini-css-extract-plugin
export var paginationContainer = "_5p-0";